// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseCustomerFactory instead of class inheritance

import { createBaseCustomer, type IBaseCustomer } from "../BaseCustomerFactory";
import type { OfficeFolder } from "le-coffre-resources/dist/Customer";
import type { OfficeFolder as OfficeFolderNotary } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../types";
import type { IGetFoldersParams } from "./Folders";

interface FoldersInstance {
	get(q: IGetFoldersParams): Promise<OfficeFolder[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<OfficeFolderNotary>;
}

// Module-level singleton instance
let instance: FoldersInstance | null = null;
let baseCustomerInstance: IBaseCustomer | null = null;

function createFolders(): FoldersInstance {
	if (!baseCustomerInstance) {
		baseCustomerInstance = createBaseCustomer();
	}

	const baseCustomer = baseCustomerInstance;
	const baseUrl = baseCustomer.namespaceUrl.concat("/folders");

	return {
		get: async (q: IGetFoldersParams): Promise<OfficeFolder[]> => {
			const url = new URL(baseUrl);
			baseCustomer.appendJsonSearchParams(url, q);
			try {
				return await baseCustomer.getRequest<OfficeFolder[]>(url);
			} catch (err) {
				baseCustomer.onError(err);
				return Promise.reject(err);
			}
		},
		getByUid: async (uid: string, q?: QueryPayload): Promise<OfficeFolderNotary> => {
			const url = new URL(baseUrl.concat(`/${uid}`));
			if (q) baseCustomer.appendJsonSearchParams(url, q);
			try {
				return await baseCustomer.getRequest<OfficeFolderNotary>(url);
			} catch (err) {
				baseCustomer.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getFoldersInstance(): FoldersInstance {
	if (!instance) {
		instance = createFolders();
	}
	return instance;
}
